import { render, staticRenderFns } from "./FormUnitBasicLocale.vue?vue&type=template&id=09a1691b&scoped=true&"
import script from "./FormUnitBasicLocale.vue?vue&type=script&lang=js&"
export * from "./FormUnitBasicLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a1691b",
  null
  
)

export default component.exports